module.exports = __webpack_public_path__ + "img/app_store_tongue.f9d8b35d.jpg";